import { useEffect, useState } from 'react';

const getDocumentVisibilityState = () => {
  if (typeof document === 'undefined') {
    return false;
  }
  return document.visibilityState === 'visible';
};

const useGetPageVisible = () => {
  const [isDocVisible, setIsDocVisible] = useState(
    getDocumentVisibilityState(),
  );
  const [isMouseIn, setIsMouseIn] = useState(false);

  useEffect(() => {
    const handleMouseEnter = () => {
      setIsMouseIn(true);
    };
    const handleMouseLeave = () => {
      setIsMouseIn(false);
    };
    const handleUpdateDocVisible = () => {
      setIsDocVisible(getDocumentVisibilityState());
    };

    document.addEventListener('visibilitychange', handleUpdateDocVisible);
    document.addEventListener('mouseenter', handleMouseEnter);
    document.addEventListener('mouseleave', handleMouseLeave);

    return () => {
      document.removeEventListener('visibilitychange', handleUpdateDocVisible);
      document.removeEventListener('mouseenter', handleMouseEnter);
      document.removeEventListener('mouseleave', handleMouseLeave);
    };
  }, []);

  return {
    isDocVisible,
    isMouseIn,
  };
};

export default useGetPageVisible;
